import React, { useContext } from "react";

import { APP_INSIGHTS_EVENTS, STOCKPILES_OUTPUT_PARAMS } from "../../constants";
import { MatchContext } from "../../context";
import { SET_HIGHLIGHTED_COLS } from "../../reduce/actionTypes";
import StyledTableCell from "./styled-table-cell.component";
import useStyles from "../tables-container/styles";
import useHighlightTableItem from "../../utils/hooks/use-higlight-table-item";

const DataCell = ({
  feature,
  stockpiles,
  handleStockpileDoubleClick,
  handleStockpileHover,
  hoveredStockpile,
}): JSX.Element => {
  const classes = useStyles();
  const start = STOCKPILES_OUTPUT_PARAMS.START_DATE;
  const end = STOCKPILES_OUTPUT_PARAMS.END_DATE;
  const { state } = useContext(MatchContext);
  const higlightTableItem = useHighlightTableItem();

  const prepareStyles = (stockpile: string) => {
    let classNames = `${classes.dataCell}`;

    if (state.highlightedCols?.includes(stockpile))
      classNames += " highlighted";

    if (state.forecastedStockpile === stockpile)
      classNames += " double-highlighted";

    //highlighted-on-hover
    if (hoveredStockpile === stockpile) classNames += " highlighted-on-hover";

    return classNames;
  };

  return (
    <React.Fragment>
      {stockpiles?.map((item) => (
        <StyledTableCell
          key={item.stockpile}
          align="center"
          className={prepareStyles(item.stockpile)}
          onClick={() =>
            higlightTableItem(
              item.stockpile,
              SET_HIGHLIGHTED_COLS,
              "highlightedCols",
              APP_INSIGHTS_EVENTS.CHANGE_COL_HIGHLIGHT
            )
          }
          onDoubleClick={() => handleStockpileDoubleClick(item.stockpile)}
          onMouseEnter={() => handleStockpileHover(item.stockpile)}
          onMouseLeave={() => handleStockpileHover("")}
        >
          {feature === start || feature === end
            ? item.value.split(" ")[0]
            : parseFloat(item.value).toFixed(2)}
        </StyledTableCell>
      ))}
    </React.Fragment>
  );
};

export default DataCell;
